<template lang="pug">
div(v-if="clientId")

    div(v-if="layout === 'home' && showCaraButton" class="px-3 mt-3")
        div(class="cara-cta d-flex align-items-center" @click="openCaraModal")
            div(class="cara-cta-icon d-flex justify-content-center align-items-center")
                img(src="@/assets/cara-logo.png" alt="CARA" class="cara-cta-logo")
            div(class="cara-cta-text flex-fill")
                h6.mb-0 CARA
                small {{ caraMode === 'update' ? 'Update membership' : 'Register / Update membership' }}
            b-icon(icon="chevron-right" class="cara-cta-chevron")


    div(v-else-if="layout === 'profile'" class="cara-profile-card p-3")
        div(class="d-flex align-items-center mb-2" style="gap:0.5rem;")
            b-icon(icon="card-checklist" class="cara-profile-icon")
            span(class="cara-profile-title") CARA Membership
        b-skeleton(v-if="statusLoading" width="60%" height="1rem")
        template(v-else-if="caraMode === 'update' && caraExistingId")
            span(class="cara-profile-label") Membership No.
            p(class="m-0 cara-profile-value") {{ caraExistingId }}
            b-button.my-2(variant="success"  @click="openCaraModal") Update membership No
        template(v-else-if="caraState === 'pending'")
            div(class="d-flex align-items-center cara-profile-pending" style="gap:0.4rem;")
                b-icon(icon="hourglass-split")
                span Registration submitted
            p(class="cara-profile-blurb mb-0 mt-1") We're waiting for your CARA membership card to be created.
        template(v-else)
            p(class="cara-profile-blurb mb-2") Not a CARA member yet? Register your interest to access safety and support features for you and your loved one.
            div(class="d-flex flex-column align-items-start" style="gap:0.5rem;")
                b-button.my-2(variant="outline-primary" size="sm" class="cara-know-more-btn" @click="openCaraKnowMore")
                        b-icon.mx-2(icon="info-circle" class="mr-1")
                        | Know more about CARA
                        b-icon.mx-2(icon="box-arrow-up-right" class="ml-1 cara-know-more-ext")
                b-button(variant="success" size="sm" @click="openCaraModal") Register for CARA
                b-button(variant="outline-primary" size="sm" class="cara-have-card-btn" @click="openCaraCardEntry")
                    b-icon(icon="card-checklist" class="mr-1")
                    | Already have a card? Enter number
                


    b-modal(v-model="showCaraModal" centered hide-footer hide-header body-class="cara-modal-body" content-class="cara-modal-content" :no-close-on-backdrop="isAutoPrompt" :no-close-on-esc="isAutoPrompt")
        div(v-if="!caraDone")
            template(v-if="modalView === 'register'")
                div(class="cara-modal-head text-center")
                    img(src="@/assets/cara-logo.png" alt="CARA" class="cara-info-logo")
                    p.cara-modal-subtitle Membership Programme
                    b-button(variant="link" class="cara-modal-close" @click="showCaraModal = false" aria-label="Close")
                        b-icon(icon="x")
                div(class="cara-info")
                    p Dear Caregivers,
                    p As part of our ongoing efforts to better support persons living with dementia and their caregivers, we invite you to consider signing up for the CARA Membership Programme, if you have not already done so.
                    p CARA Membership is a free programme by Dementia Singapore that enhances safety, support, and community connectivity for persons living with dementia and their caregivers.
                    h6.cara-info-heading About CARA Membership
                    p.mb-1 CARA stands for:
                    ul.cara-info-list
                        li #[strong Care] – Access to dementia-related information, resources, and community support
                        li #[strong Assurance] – Safety features (e.g. Safe Return) to help reunite loved ones if they go missing
                        li #[strong Rewards] – Access to curated services, privileges, and partner offers
                        li #[strong Acceptance] – Participation in a growing network of dementia-inclusive partners
                    h6.cara-info-heading Key Benefits
                    p.mb-1 #[strong For Persons Living with Dementia]
                    ul.cara-info-list
                        li Issuance of a physical CARA membership card for identification and safety
                        li Access to Safe Return support, enabling quicker assistance if they become lost
                    p.mb-1 #[strong For Caregivers]
                    ul.cara-info-list
                        li Access to the CARA mobile app, including:
                            ul
                                li Safe Return function
                                li Report Missing Person feature
                                li Dementia Go-To-Point Locator
                    p These features provide added reassurance and practical support in your caregiving journey.
                    div(class="text-center")
                        b-button(variant="outline-primary" size="sm" class="cara-know-more-btn my-2" @click="openCaraKnowMore")
                            b-icon.mx-2(icon="info-circle" class="mr-1")
                            | Know more about CARA
                            b-icon.mx-2(icon="box-arrow-up-right" class="ml-1 cara-know-more-ext")
                div(class="d-flex flex-column mt-3" style="gap: 0.6rem;")
                    b-button(variant="success" @click="registerCara" :disabled="caraSubmitting")
                        b-spinner(small v-if="caraSubmitting")
                        span(v-else) Register Now
                    b-button(variant="outline-danger" @click="declineCara" :disabled="caraSubmitting") Not Interested
                    b-button(v-if="isAutoPrompt" variant="link" class="cara-remind-later" @click="remindCaraLater" :disabled="caraSubmitting") Remind me later
                div(class="cara-have-card mt-3 pt-3 text-center")
                    p.my-2.small.font-weight-bold Already have CARA membership card?
                    b-button(variant="outline-success" size="sm" class="cara-have-card-btn" @click="modalView = 'update'")
                        b-icon(icon="card-checklist" class="mr-1")
                        | Enter your membership number

            template(v-else)
                div(class="cara-modal-head cara-modal-head-update text-center")
                    div(class="d-flex align-items-center justify-content-between")
                        b-button(v-if="caraMode !== 'update'" variant="link" class="cara-back-link p-0" @click="modalView = 'register'")
                            b-icon(icon="chevron-left")
                            |  Back
                        span(v-else)
                        b-button(variant="link" class="cara-modal-close position-static p-0" @click="showCaraModal = false" aria-label="Close")
                            b-icon(icon="x")
                    img(src="@/assets/cara-logo.png" alt="CARA" class="cara-info-logo cara-info-logo-sm")
                    p.cara-modal-subtitle {{ caraMode === 'update' ? 'Update Membership' : 'Confirm Your Card' }}
                p.text-muted.text-center.px-2 Enter your CARA membership number:
                div(class="cara-card-hint text-center my-3")
                    div(class="cara-card-wrap")
                        span(class="cara-card-sample-badge") SAMPLE
                        img(src="@/assets/cara_card_sample.png" alt="Sample CARA membership card" class="cara-card-img")
                    span(class="cara-card-ref d-block mt-3") CARD FOR REFERENCE ONLY
                    small.text-muted.d-block.mt-2 Your membership number is printed on your own card, as shown above.
                div(class="cara-input-group")
                    label(class="cara-input-label") Membership Number
                    b-form-input(v-model="caraIdInput" placeholder="e.g. D199C00002" class="cara-id-input text-center" :disabled="caraSubmitting" :formatter="toUpperCaraId")
                div(class="d-flex flex-column mt-4" style="gap: 0.6rem;")
                    b-button(variant="primary" class="cara-modal-btn" @click="submitCaraUpdate" :disabled="caraSubmitting || !caraIdInput.trim()")
                        b-spinner(small v-if="caraSubmitting")
                        span(v-else) Submit
                    b-button(v-if="isAutoPrompt" variant="link" class="cara-remind-later" @click="remindCaraLater" :disabled="caraSubmitting") Remind me later
        div(v-else class="text-center py-4")
            div(class="cara-done-icon mx-auto mb-3")
                b-icon(icon="check-lg" variant="white")
            p.cara-done-msg.mb-4 {{ caraMessage }}
            b-button(variant="primary" class="cara-modal-btn w-100" @click="showCaraModal = false") Done
</template>

<script>
export default {
    name: 'CaraMembership',
    props: {
        clientId: { type: String, default: null },
        caregiverId: { type: String, default: null },

        layout: { type: String, default: 'home' },

        // When true, the component may open the prompt by itself for caregivers
        // who have not responded yet. The parent owns this so it can hold the
        // prompt back while its own modals are on screen.
        autoPrompt: { type: Boolean, default: false },
    },
    data() {
        return {
            showCaraButton: false,
            caraMode: 'register',
            caraExistingId: null,
            caraState: 'new',
            statusLoading: false,
            showCaraModal: false,
            modalView: 'register',
            caraIdInput: '',
            caraSubmitting: false,
            caraDone: false,
            caraMessage: '',
            // True while the open modal was triggered automatically rather than
            // by a tap, which makes it harder to dismiss by accident.
            isAutoPrompt: false,
        };
    },
    watch: {
        clientId: {
            handler(val) {
                if (val) this.fetchCaraStatus();
            },
            immediate: true,
        },
        autoPrompt(val) {
            // Typically flips true once the parent's own popups have been closed.
            if (val) this.maybeAutoPrompt();
        },
        showCaraModal(val) {
            if (!val) this.isAutoPrompt = false;
        },
    },
    mounted() {
        this.refreshOnReturn = () => {
            if (document.visibilityState === 'visible') this.fetchCaraStatus();
        };
        document.addEventListener('visibilitychange', this.refreshOnReturn);
        window.addEventListener('focus', this.refreshOnReturn);
    },
    beforeDestroy() {
        document.removeEventListener('visibilitychange', this.refreshOnReturn);
        window.removeEventListener('focus', this.refreshOnReturn);
    },
    methods: {
        buildCaraFormUrl() {
            const url = new URL('https://dsg-form.pages.dev/cara');
            if (this.clientId) url.searchParams.set('client_id', this.clientId);
            if (this.caregiverId) url.searchParams.set('caregiver_id', this.caregiverId);
            return url.toString();
        },
        async fetchCaraStatus() {
            if (!this.clientId) return;
            this.statusLoading = true;
            try {
                const { data } = await this.$root.axios.get(`/cara/${this.clientId}`);
                this.showCaraButton = !!data.showButton;
                this.caraMode = data.mode || 'register';
                this.caraExistingId = data.existingCaraId || null;
                this.caraState = data.state || 'new';
                this.maybeAutoPrompt();
            } catch (err) {
                console.error('Error fetching CARA status', err);
                this.showCaraButton = false;
            } finally {
                this.statusLoading = false;
            }
        },
        promptStorageKey() {
            return `cara_prompt_shown_${this.clientId}`;
        },
        todayStamp() {
            const d = new Date();
            return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
        },
        maybeAutoPrompt() {
            if (this.layout !== 'home') return;
            if (!this.autoPrompt || !this.clientId) return;
            if (!this.showCaraButton) return;
            if (this.showCaraModal) return;

            let lastShown = null;
            try {
                lastShown = localStorage.getItem(this.promptStorageKey());
            } catch (e) {
                // Private mode or storage disabled: fall through and just prompt.
            }
            if (lastShown === this.todayStamp()) return;

            try {
                localStorage.setItem(this.promptStorageKey(), this.todayStamp());
            } catch (e) {
                // Not fatal — worst case the prompt shows again next navigation.
            }

            this.openCaraModal();
            this.isAutoPrompt = true;
        },
        remindCaraLater() {
            // Already recorded as shown for today, so simply closing is enough.
            this.showCaraModal = false;
        },
        openCaraModal() {
            this.caraIdInput = '';
            this.caraDone = false;
            this.caraMessage = '';
            // Existing members go straight to the membership-number form; everyone
            // else starts on the info/register view.
            this.modalView = this.caraMode === 'update' ? 'update' : 'register';
            this.showCaraModal = true;
        },
        openCaraCardEntry() {
            // Open the modal directly on the membership-number form for caregivers
            // who already hold a CARA card but aren't in the system yet.
            this.openCaraModal();
            this.modalView = 'update';
        },
        registerCara() {
            window.open(this.buildCaraFormUrl(), '_blank', 'noopener,noreferrer');
            this.showCaraModal = false;
        },
        openCaraKnowMore() {
            window.open('https://dementia.org.sg/services/cara/', '_blank', 'noopener,noreferrer');
        },
        toUpperCaraId(value) {
            return value.toUpperCase();
        },
        async submitCaraUpdate() {
            const caraId = this.caraIdInput.trim();
            if (!caraId) return;
            this.caraSubmitting = true;
            try {
                const { data } = await this.$root.axios.post('/cara/update', {
                    clientId: this.clientId,
                    caregiverId: this.caregiverId,
                    caraId,
                });
                this.caraMessage = data.matched
                    ? 'This matches our records. Thank you for confirming your CARA membership.'
                    : 'Your CARA membership number has been updated. Thank you!';
                this.caraDone = true;
                this.showCaraButton = false;
                await this.fetchCaraStatus();
            } catch (err) {
                console.error('Error updating CARA membership', err);
                this.$bvToast.toast('Something went wrong. Please try again.', { title: 'CARA', variant: 'danger', solid: true });
            } finally {
                this.caraSubmitting = false;
            }
        },
        async declineCara() {
            this.caraSubmitting = true;
            try {
                await this.$root.axios.post('/cara/not-interested', {
                    clientId: this.clientId,
                    caregiverId: this.caregiverId,
                });
                this.caraMessage = "No problem — we won't ask again.";
                this.caraDone = true;
                this.showCaraButton = false;
            } catch (err) {
                console.error('Error recording CARA decline', err);
                this.$bvToast.toast('Something went wrong. Please try again.', { title: 'CARA', variant: 'danger', solid: true });
            } finally {
                this.caraSubmitting = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.cara-cta {
    position: relative;
    overflow: hidden;
    gap: 0.9rem;
    padding: 0.9rem 1rem;
    border-radius: 14px;
    cursor: pointer;
    color: #fff;
    background: #8967B3;
    box-shadow: 0 6px 18px rgba(137, 103, 179, 0.28);
    transition: transform 0.25s ease, box-shadow 0.25s ease;

    animation: caraCtaPulse 2.8s ease-in-out infinite;


    &::after {
        content: "";
        position: absolute;
        top: 0;
        left: -75%;
        width: 45%;
        height: 100%;
        pointer-events: none;
        background: linear-gradient(
            100deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.28) 50%,
            rgba(255, 255, 255, 0) 100%
        );
        transform: skewX(-18deg);
        animation: caraCtaSheen 4.6s ease-in-out infinite;
    }

    // Let the hover/press state read cleanly instead of fighting the pulse.
    &:hover,
    &:active {
        transform: translateY(-2px);
        box-shadow: 0 10px 24px rgba(137, 103, 179, 0.36);
        animation-play-state: paused;

        &::after {
            animation-play-state: paused;
        }
    }

    .cara-cta-icon {
        width: 42px;
        height: 42px;
        flex-shrink: 0;
        border-radius: 12px;
        background: #fff;
        font-size: 1.2rem;

        .cara-cta-logo {
            width: 32px;
            height: 32px;
            object-fit: contain;
        }
    }

    .cara-cta-text {
        h6 {
            font-weight: 700;
        }
        small {
            opacity: 0.9;
            line-height: 1.2;
        }
    }

    .cara-cta-chevron {
        flex-shrink: 0;
        opacity: 0.85;

        animation: caraCtaNudge 2.8s ease-in-out infinite;
    }
}

.cara-remind-later {
    color: #6c757d;
    font-size: 0.85rem;
    text-decoration: underline;

    &:hover {
        color: #495057;
    }
}

@keyframes caraCtaPulse {
    0%,
    100% {
        box-shadow: 0 6px 18px rgba(137, 103, 179, 0.28);
    }
    50% {
        box-shadow:
            0 8px 22px rgba(137, 103, 179, 0.45),
            0 0 0 6px rgba(137, 103, 179, 0.16);
    }
}

@keyframes caraCtaSheen {

    0%,
    55% {
        left: -75%;
    }
    92%,
    100% {
        left: 130%;
    }
}

@keyframes caraCtaNudge {
    0%,
    60%,
    100% {
        transform: translateX(0);
    }
    75% {
        transform: translateX(3px);
    }
}


@media (prefers-reduced-motion: reduce) {
    .cara-cta,
    .cara-cta .cara-cta-chevron {
        animation: none;
    }

    .cara-cta::after {
        display: none;
    }
}

.cara-profile-card {
    background: #fff;
    border: 1px solid #e8dff4;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(89, 36, 107, 0.06);

    .cara-profile-icon {
        color: #8967b3;
        font-size: 1rem;
    }
    .cara-profile-title {
        font-size: 0.85rem;
        color: #666;
        font-weight: 500;
    }
    .cara-profile-label {
        font-size: 0.72rem;
        color: #8967b3;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.03em;
    }
    .cara-profile-value {
        font-size: 1rem;
        font-weight: 700;
        color: #26263e;
        letter-spacing: 0.02em;
    }
    .cara-profile-blurb {
        font-size: 0.85rem;
        color: #555;
    }
    .cara-profile-pending {
        font-size: 0.88rem;
        font-weight: 600;
        color: #8967b3;
    }
}

.cara-modal-btn {
    background-color: #8967B3;
    border-color: #8967B3;

    &:hover, &:focus, &:active {
        background-color: #785aa0;
        border-color: #785aa0;
    }
}
.cara-info-logo {
    height: 42px;
    width: auto;
    object-fit: contain;

    &.cara-info-logo-sm {
        height: 30px;
    }
}
.cara-modal-head {
    position: relative;
    padding: 0.5rem 0 1rem;
    margin-bottom: 0.5rem;
    border-bottom: 1px solid #f0e9f7;

    .cara-modal-subtitle {
        margin: 0.35rem 0 0;
        font-size: 0.78rem;
        font-weight: 600;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #a98fce;
    }
}
.cara-modal-close {
    position: absolute;
    top: -0.25rem;
    right: -0.25rem;
    color: #b3a3c7;
    font-size: 1.3rem;
    line-height: 1;

    &:hover, &:focus {
        color: #8967B3;
    }
}
.cara-info {
    max-height: 52vh;
    overflow-y: auto;
    padding-right: 0.65rem;
    font-size: 0.92rem;
    line-height: 1.6;
    color: #4a4a55;

    p {
        margin-bottom: 0.85rem;
    }

    .cara-info-heading {
        margin-top: 1.35rem;
        margin-bottom: 0.55rem;
        padding-left: 0.6rem;
        font-size: 1rem;
        font-weight: 700;
        color: #8967B3;
        border-left: 3px solid #c9aee8;
    }

    .cara-info-list {
        padding-left: 1.3rem;
        margin-bottom: 0.9rem;

        li {
            margin-bottom: 0.45rem;
        }

        ul {
            padding-left: 1.3rem;
            margin-top: 0.45rem;
        }
    }
}
.cara-modal-head-update {
    padding-top: 0;
}
.cara-card-hint {
    background: #faf7fd;
    border: 1px solid #f0e9f7;
    border-radius: 14px;
    padding: 1rem 0.75rem;

    .cara-card-wrap {
        position: relative;
        display: inline-block;
    }
    .cara-card-img {
        max-width: 200px;
        width: 70%;
        height: auto;
        border-radius: 12px;
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
    }
    .cara-card-sample-badge {
        position: absolute;
        top: 50px;
        left: 50%;
        transform: translateX(-50%) rotate(-8deg);
        background: rgba(253, 48, 48, 0.92);
        color: #fff;
        font-size: 0.7rem;
        font-weight: 700;
        letter-spacing: 0.12em;
        padding: 0.2rem 0.9rem;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        pointer-events: none;
    }
    .cara-card-ref {
        font-size: 0.68rem;
        font-weight: 700;
        letter-spacing: 0.1em;
        color: #d63030;
    }
}
.cara-done-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: linear-gradient(135deg, #7bc47f 0%, #4caf50 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    box-shadow: 0 6px 18px rgba(76, 175, 80, 0.35);
}
.cara-done-msg {
    font-size: 0.98rem;
    font-weight: 500;
    color: #3a3a45;
}
.cara-input-group {
    margin-top: 1.25rem;

    .cara-input-label {
        display: block;
        margin-bottom: 0.4rem;
        font-size: 0.72rem;
        font-weight: 700;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: #8967B3;
        text-align: center;
    }
    .cara-id-input {
        border-radius: 12px;
        border: 1.5px solid #d8c4ec;
        padding: 0.7rem 1rem;
        font-size: 1.1rem;
        font-weight: 700;
        letter-spacing: 0.08em;
        color: #26263e;

        &::placeholder {
            font-weight: 400;
            letter-spacing: normal;
            color: #b7b0c2;
        }
        &:focus {
            border-color: #8967B3;
            box-shadow: 0 0 0 0.2rem rgba(137, 103, 179, 0.18);
        }
    }
}
.cara-know-more-btn {
    color: #8967B3;
    border-color: #d8c4ec;
    background: #f6f1fb;
    border-radius: 999px;
    font-weight: 600;
    padding: 0.35rem 1.1rem;
    transition: all 0.2s ease;

    &:hover, &:focus, &:active {
        color: #fff !important;
        background: #8967B3 !important;
        border-color: #8967B3 !important;
        box-shadow: 0 3px 10px rgba(137, 103, 179, 0.3);
    }

    .cara-know-more-ext {
        font-size: 0.7rem;
        opacity: 0.75;
    }
}

.cara-have-card {
    border-top: 1px dashed #e0d3f0;

    .cara-have-card-btn {
        color: #8967B3;
        border-color: #8967B3;
        // border-radius: 15px;
        font-weight: 600;

        &:hover, &:focus, &:active {
            color: #fff !important;
            background: #8967B3 !important;
            border-color: #8967B3 !important;
        }
    }
}

.cara-back-link {
    color: #8967B3;
    font-weight: 600;
    text-decoration: none;

    &:hover, &:focus {
        color: #785aa0;
        text-decoration: underline;
    }
}
</style>

<!-- Unscoped: b-modal renders its content via a portal, outside the scoped tree -->
<style lang="scss">
.cara-modal-content {
    border: none;
    border-radius: 18px;
    box-shadow: 0 18px 50px rgba(89, 36, 107, 0.22);
    overflow: hidden;
}
.cara-modal-body {
    padding: 1.5rem 1.5rem 1.75rem;
}
</style>
